/* Danver Paw — interacciones propias (vanilla, sin librerías) */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Reveal al hacer scroll (un único observer compartido) */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.dp-reveal:not(.dp-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('dp-visible'); });
      return;
    }
    if (!window.__dpObs) {
      window.__dpObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('dp-visible'); window.__dpObs.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { window.__dpObs.observe(el); });
  }

  /* Parallax suave del hero */
  function initParallax() {
    var imgs = document.querySelectorAll('[data-dp-parallax]');
    if (!imgs.length || reduce) return;
    var ticking = false;
    function update() {
      imgs.forEach(function (img) {
        var r = img.parentElement.getBoundingClientRect();
        var k = parseFloat(img.getAttribute('data-dp-parallax')) || 0;
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        img.style.transform = 'translate3d(0,' + (-r.top * k / 100) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* Cifras animadas */
  function initCount() {
    var els = document.querySelectorAll('[data-dp-count]:not([data-dp-done])');
    if (!els.length) return;
    function run(el) {
      el.setAttribute('data-dp-done', '1');
      var end = parseFloat(el.getAttribute('data-dp-count')) || 0;
      if (reduce) { el.textContent = end; return; }
      var t0 = null, dur = 1400;
      function step(t) {
        if (!t0) t0 = t;
        var p = Math.min((t - t0) / dur, 1);
        el.textContent = Math.round(end * (1 - Math.pow(1 - p, 3)));
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Comparador antes/después */
  function initSliders() {
    document.querySelectorAll('.dp-slider').forEach(function (s) {
      var range = s.querySelector('.dp-slider__range');
      if (!range || range.__dp) return;
      range.__dp = true;
      function set() { s.style.setProperty('--pos', range.value + '%'); }
      range.addEventListener('input', set);
      set();
    });
  }

  /* Escena sticky de pasos */
  function initSteps() {
    document.querySelectorAll('.dp-steps').forEach(function (sec) {
      var steps = sec.querySelectorAll('.dp-step');
      var imgs = sec.querySelectorAll('.dp-steps__frame img');
      var bars = sec.querySelectorAll('.dp-steps__progress span');
      if (!steps.length || !('IntersectionObserver' in window)) return;
      function activate(i) {
        steps.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        imgs.forEach(function (im, k) { im.classList.toggle('is-active', k === i); });
        bars.forEach(function (b, k) { b.classList.toggle('is-done', k <= i); });
      }
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (e) {
          if (e.isIntersecting) activate(Array.prototype.indexOf.call(steps, e.target));
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      steps.forEach(function (s) { io.observe(s); });
      activate(0);
    });
  }

  /* Puntos de ingredientes */
  function initHotspots() {
    document.querySelectorAll('.dp-hot__btn').forEach(function (b) {
      if (b.__dp) return;
      b.__dp = true;
      b.addEventListener('click', function () {
        var hot = b.closest('.dp-hot');
        var open = hot.classList.contains('is-open');
        hot.parentElement.querySelectorAll('.dp-hot').forEach(function (h) { h.classList.remove('is-open'); });
        if (!open) hot.classList.add('is-open');
        b.setAttribute('aria-expanded', String(!open));
      });
    });
  }

  /* Página de producto: galería + variantes + barra fija móvil */
  function initProduct() {
    document.querySelectorAll('[data-dp-product]').forEach(function (root) {
      if (root.__dp) return;
      root.__dp = true;
      var main = root.querySelector('.dp-gallery__main img');
      root.querySelectorAll('.dp-gallery__thumb').forEach(function (t) {
        t.addEventListener('click', function () {
          root.querySelectorAll('.dp-gallery__thumb').forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
          if (main) {
            main.style.opacity = 0;
            setTimeout(function () {
              main.src = t.getAttribute('data-src');
              main.srcset = t.getAttribute('data-srcset') || '';
              main.alt = t.getAttribute('data-alt') || '';
              main.style.opacity = 1;
            }, 180);
          }
        });
      });

      var dataEl = root.querySelector('[data-dp-variants]');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var idInput = root.querySelector('input[name="id"]');
      var priceEl = root.querySelector('[data-dp-price]');
      var compareEl = root.querySelector('[data-dp-compare]');
      var unitEl = root.querySelector('[data-dp-unit]');
      var btn = root.querySelector('[data-dp-add]');
      var btnText = btn ? btn.querySelector('span') : null;
      var stickyPrice = document.querySelector('[data-dp-sticky-price]');

      function apply(v) {
        if (!v) return;
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = v.price_f;
        if (stickyPrice) stickyPrice.textContent = v.price_f;
        if (compareEl) { compareEl.textContent = v.compare_f || ''; compareEl.hidden = !v.compare_f; }
        if (unitEl) { unitEl.textContent = v.unit_f || ''; unitEl.hidden = !v.unit_f; }
        if (btn) {
          btn.disabled = !v.available;
          if (btnText) btnText.textContent = v.available ? btn.getAttribute('data-txt-add') : btn.getAttribute('data-txt-soldout');
        }
        if (v.image && main) {
          var th = root.querySelector('.dp-gallery__thumb[data-media="' + v.image + '"]');
          if (th) th.click();
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      root.querySelectorAll('input[name="dp-variant"]').forEach(function (r) {
        r.addEventListener('change', function () {
          var id = parseInt(r.value, 10);
          apply(variants.filter(function (v) { return v.id === id; })[0]);
        });
      });

      /* Selector por opciones (animal, color, talla) */
      var optInputs = root.querySelectorAll('input[data-dp-option]');
      if (optInputs.length) {
        var groups = root.querySelectorAll('[data-dp-opt]');
        function selected() {
          var vals = [];
          groups.forEach(function (g) {
            var c = g.querySelector('input:checked');
            vals[parseInt(g.getAttribute('data-dp-opt'), 10)] = c ? c.value : null;
          });
          return vals;
        }
        function refreshAvailability(vals) {
          groups.forEach(function (g) {
            var oi = parseInt(g.getAttribute('data-dp-opt'), 10);
            g.querySelectorAll('input[data-dp-option]').forEach(function (inp) {
              var test = vals.slice(); test[oi] = inp.value;
              var ok = variants.some(function (v) {
                return v.available && v.options.every(function (o, k) { return k === oi || test[k] == null || o === test[k]; });
              });
              inp.closest('.dp-pill').classList.toggle('is-off', !ok);
            });
          });
        }
        optInputs.forEach(function (inp) {
          inp.addEventListener('change', function () {
            var vals = selected();
            var g = inp.closest('[data-dp-opt]');
            var lab = g && g.querySelector('[data-dp-opt-val]');
            if (lab) lab.textContent = inp.value;
            var match = variants.filter(function (v) {
              return v.options.every(function (o, k) { return vals[k] == null || o === vals[k]; });
            })[0];
            if (match) apply(match);
            else if (btn) { btn.disabled = true; if (btnText) btnText.textContent = btn.getAttribute('data-txt-soldout'); }
            refreshAvailability(vals);
          });
        });
        refreshAvailability(selected());
      }

      var bar = document.querySelector('.dp-sticky-buy');
      if (bar && btn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          en.forEach(function (e) { bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0); });
        }).observe(btn);
        var go = bar.querySelector('button');
        if (go) go.addEventListener('click', function () { btn.click(); });
      }
    });
  }

  function initAll(root) {
    initReveal(root); initCount(); initSliders(); initSteps(); initHotspots(); initProduct();
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(); initParallax(); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
